// TODO: Handle product click
// TODO: Keep in memory the previous selected product when switching between categories

class GuideTaillesV2 {
    constructor() {
        this.selectedCategoryId = 0;
        this.selectedProductId = 0;
        this.categoriesButtons = document.querySelectorAll('.category-name');
        this.categoriesProductsSections = document.querySelectorAll('.models-section');
        this.productsButtons = document.querySelectorAll('.product-name');
        this.productsInfo = document.querySelectorAll('.product-info');
        this.events();
    }

    events() {
        this.initStyles();
        this.addEventListeners();
    }

    /**
     * Init styles by removing the opacity rule on the first category element and removing the hidden property on the first products section
     * @since 1.0.0
     */
    initStyles() {
        // Removing opacity 30 for the first category button
        if (this.categoriesButtons) {
            this.categoriesButtons[0].classList.remove('opacity-30');
        }

        if (this.categoriesProductsSections) {
            // Removing the opacity rule for the first product of each category
            for (let index = 0; index < (this.categoriesProductsSections).length; index++) {
                let sectionClass = `.models-section-${index} .product-name`;
                document.querySelector(sectionClass).classList.remove('opacity-30');
            }
            // Removing the hidden rule for the first section of products for the first category
            this.categoriesProductsSections[0].classList.remove('hidden');
            // if (document.querySelector('.product-0')) {
            //     document.querySelector('.product-0').classList.remove('hidden');
            //     document.querySelector('.product-0').classList.add('grid');
            // }
        }
    }

    /**
     * Event listeners for categories button and products buttons
     * @since 1.0.0
     */
    addEventListeners() {
        if (this.categoriesButtons && this.categoriesProductsSections) {
            (this.categoriesButtons).forEach(categoryButton => {
                categoryButton.addEventListener("click", (e) => {
                    e.preventDefault();
                    this.categoryButtonClicked(categoryButton);
                });
            });
        }

        if (this.categoriesProductsSections) {
            // for (let index = 0; index < (this.categoriesProductsSections).length; index++) {
            //     let classes = '.products-category-' + index;
            //     console.log(classes);
            //     let products = document.querySelectorAll(classes);
            //     products.forEach(product => {
            //         product.addEventListener("click", (e) => {
            //             e.preventDefault();
            //             this.productButtonClicked(products, product);
            //         })
            //     });
            // }
            (this.productsButtons).forEach(element => {
                element.addEventListener("click", (e) => {
                    e.preventDefault();

                    (this.productsButtons).forEach(element => {
                        const productId = (e.target).getAttribute('data-key');
                        const selectedProductId = element.getAttribute('data-key');

                        if (productId == selectedProductId) { element.classList.remove('opacity-30'); } else { element.classList.add('opacity-30'); }
                        // if (element.getAttribute('data-key') === (e.target).getAttribute('data-key')) {
                        //     e.target.classList.remove('opacity-30');
                        // } else {
                        //     e.target.classList.add('opacity-30');
                        // }
                    });

                    // element.classList.add('opacity-30');
                    // const id = (e.target).getAttribute('data-key');

                    // if (element.getAttribute('data-key') === id) {
                    //     element.classList.remove('opacity-30');
                    // }

                    // (this.productsInfo).forEach(product => {
                    //     if (product.getAttribute('data-key') === id) {
                    //         product.classList.remove('hidden');
                    //         product.classList.add('grid');
                    //     } else {
                    //         product.classList.add('hidden');
                    //         product.classList.remove('grid');
                    //     }
                    // });
                })
            });
        }
    }

    /**
     * Category Button clicked
     * @since 1.0.0
     */
    categoryButtonClicked(categoryButton) {
        this.selectedCategoryId = categoryButton.getAttribute('data-key');
        // Reseting buttons opacity to 30%
        this.resetCategoryButtonsStyles();
        // Change style of the selected category button
        this.changeSelectedElementButtonStyle(categoryButton);
        // Display related products of selected  category
        this.displayProductsOfSelectedCategory();
    }

    /**
     * Product Button clicked
     * @since 1.0.0
     */
    productButtonClicked(products, product) {
        this.selectedProductId = product.getAttribute('data-key');
        // Reseting buttons opacity to 30%
        this.resetProductButtonsStyles(products);
        // Change style of the selected product button
        this.changeSelectedElementButtonStyle(product);
        // Display info of selected product
        this.displaySelectedProductInformations();

        console.log('clicked');
    }

    /**
     * Change selected element button style
     * @since 1.0.0
     */
    changeSelectedElementButtonStyle(categoryButton) {
        categoryButton.classList.remove('opacity-30');
    }

    /**
     * Resetting opacity for non selected category buttons
     * @since 1.0.0
     */
    resetCategoryButtonsStyles() {
        (this.categoriesButtons).forEach(categoryButton => {
            categoryButton.classList.add('opacity-30')
        })
    }

    /**
     * Resetting opacity for non selected product buttons
     * @since 1.0.0
     */
    resetProductButtonsStyles(productButtons) {
        productButtons.forEach(productButton => {
            productButton.classList.add('opacity-30')
        })
    }

    /**
     * Display products of selected category
     * @since 1.0.0
     */
    displayProductsOfSelectedCategory() {
        (this.categoriesProductsSections).forEach(section => {
            const productsSectionCategoryId = section.getAttribute('data-category-id');
            productsSectionCategoryId == this.selectedCategoryId ? section.classList.remove('hidden') : section.classList.add('hidden');
        })
    }

    /**
     * Display product info of selected product
     */
    displaySelectedProductInformations() {
        if (this.productsInfo) {
            (this.productsInfo).forEach(element => {
                const productInfoId = element.getAttribute('data-key');
                console.log(productInfoId, 'productInfoId');
                console.log(this.selectedProductId, 'this.selectedProductId');
                if (productInfoId == this.selectedProductId) {
                    element.classList.remove('hidden');
                    element.classList.add('grid');
                } else {
                    element.classList.add('hidden');
                    element.classList.remove('grid');
                }
                // productInfoId == this.selectedProductId ? element.classList.remove('hidden') : element.classList.add('hidden');
            });
        }
    }
}

export default GuideTaillesV2;